<template>
    <UiModal v-model:display="display" :title="title" :container-class="containerClass">
        <p>{{ message }}</p>
        <template #footer="{ close }">
            <UiButton variant="secondary" @click="close">{{ t("Close") }}</UiButton>
        </template>
    </UiModal>
</template>

<script setup lang="ts">
import UiModal from "@/components/utils/UiModal.vue";
import UiButton from "@/components/utils/UiButton.vue";

defineOptions({ name: "MessageModal" });

const display = defineModel<boolean>("display");

const {
    title = "",
    message = "",
    containerClass = "",
} = defineProps<{
    title?: string;
    message?: string;
    containerClass?: string;
}>();
</script>
